import { Tag } from "@faire/slate/components/tag";

import { Button } from "../../../../components/design-system";
import { ADS_MANAGER_SURFACE_CLASS } from "../constants/layout";
import { getP8HeaderStatus } from "../p8AdvertiserData";

import { AdsManagerContent } from "./AdsManagerContent";

function SettingsGearIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden>
      <path
        d="M6.5 1.5L6.1 3.3C5.7 3.5 5.3 3.7 5 3.9L3.2 3.3L1.7 5.9L3.1 7.2C3 7.5 3 7.7 3 8C3 8.3 3 8.5 3.1 8.8L1.7 10.1L3.2 12.7L5 12.1C5.3 12.3 5.7 12.5 6.1 12.7L6.5 14.5H9.5L9.9 12.7C10.3 12.5 10.7 12.3 11 12.1L12.8 12.7L14.3 10.1L12.9 8.8C13 8.5 13 8.3 13 8C13 7.7 13 7.5 12.9 7.2L14.3 5.9L12.8 3.3L11 3.9C10.7 3.7 10.3 3.5 9.9 3.3L9.5 1.5H6.5Z"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="8" cy="8" r="2" stroke="currentColor" strokeWidth="1.2" />
    </svg>
  );
}

function AdvertisingSettingsButton({
  onClick,
  className = "",
}: {
  onClick: () => void;
  className?: string;
}) {
  return (
    <Button variant="secondary" onClick={onClick} className={className}>
      <span className="inline-flex items-center gap-2">
        <SettingsGearIcon />
        Advertising settings
      </span>
    </Button>
  );
}

type PromotedListingsHeaderProps = {
  onOpenSettings: () => void;
};

export function PromotedListingsHeader({
  onOpenSettings,
}: PromotedListingsHeaderProps) {
  return (
    <div className={ADS_MANAGER_SURFACE_CLASS}>
      <AdsManagerContent className="pt-8 pb-4">
        <div className="flex items-start justify-between gap-4">
          {/* The status pill rides alongside the title rather than heading a
              second line, now that the renewal copy lives in Advertising
              settings. */}
          <div className="flex min-w-0 flex-1 flex-wrap items-center gap-3">
            <h1 className="text-[30px] leading-[38px] font-semibold text-[#333]">
              Promoted Listings
            </h1>
            <Tag
              label={getP8HeaderStatus().label}
              variant={getP8HeaderStatus().variant}
            />
          </div>
          <div className="shrink-0">
            <AdvertisingSettingsButton onClick={onOpenSettings} />
          </div>
        </div>
      </AdsManagerContent>
    </div>
  );
}
